import { useState } from 'react'
import Modal from 'react-modal'

export default function VirtualTourPopup({ virtualTourLink }) {
  const [ isOpen, toggleOpen ] = useState(false)
  const toggleBtn = document.getElementById('virtual-tour')

  if(toggleBtn) {
    toggleBtn.addEventListener('click', function() {
      toggleOpen(true)
    })
  }
  return (<Modal
    isOpen={isOpen}
    onRequestClose={() => toggleOpen(false)}
    ariaHideApp={false}
    className='Modal react-popup virtual-link'
    overlayClassName='Overlay'>
    <span className='close-btn' onClick={() => toggleOpen(false)} />
    <iframe src={virtualTourLink} className='virtual-tour iframe' width='100%' frameBorder='0' />
  </Modal>)
}
